import { Card, Detail, Time } from './GolfTeeTimeCard.styles';
import type { GolfTeeTimeCardProps } from './GolfTeeTimeCard.types';

export function GolfTeeTimeCard({
  time,
  spotsText,
  priceText,
  selected = false,
  disabled = false,
  onSelect,
  ariaLabel,
}: GolfTeeTimeCardProps) {
  return (
    <Card
      type="button"
      role="option"
      aria-selected={selected}
      aria-disabled={disabled || undefined}
      aria-label={ariaLabel}
      data-selected={selected ? 'true' : 'false'}
      disabled={disabled}
      onClick={onSelect}
    >
      <Time>{time}</Time>
      {spotsText && <Detail>{spotsText}</Detail>}
      {priceText && <Detail>{priceText}</Detail>}
    </Card>
  );
}
